import React from "react";
import Layout from "../components/Layout";
import { useParams, Link } from "react-router-dom";

export default function BlogDetail() {
  const { slug } = useParams();

  // Eyni məlumatlar burada da saxlanılmalıdır
  const blogPosts = [
    {
      title: "Yeni katalitik proses sənayedə tətbiq edildi",
      excerpt: "",
      date: "2025-02-08",
      slug: "yeni-katalitik-proses",
      image: "/images/product1.jpg",
      content: `
        Bu katalitik proses reaksiya sürətini artırır və enerjiyə ciddi qənaət edir.
        Daha yüksək məhsuldarlıq və daha stabil davranış bu texnologiyanı unikal edir.

        • Yüksək çevrilmə  
        • Enerji sərfiyyatının azalması  
        • Daha qısa reaksya müddəti  

        Prosesin sənayedə geniş tətbiqi üçün pilot layihələr davam edir.
      `
    },
    {
      title: "Scoriva konfransda yeni nano-struktur təqdim etdi",
      excerpt: "",
      date: "2025-01-29",
      slug: "nano-struktur-teqdimat",
      image: "/images/product2.jpg",
      content: `
        Yeni nano-struktur materialların dayanıqlığını artırmaqla yanaşı,
        yüksək istilik keçiriciliyi təmin edir.

        Tətbiq sahələri:
        • Elektronika  
        • Enerji sistemləri  
        • Tibbi cihazlar  
      `
    }
  ];

  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <Layout>
        <div className="container">
          <h2>Post tapılmadı</h2>
          <Link to="/blog">Bloga qayıt</Link>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <section className="section">
        <div className="container">
          <div className="card" style={{ padding: 20 }}>
            
            {/* 2 sütunlu grid */}
            <div 
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px"
              }}
            >
              {/* Sol tərəf — Şəkil */}
              <div>
                <img
                  src={post.image}
                  alt={post.title}
                  style={{
                    width: "100%",
                    borderRadius: 12,
                    objectFit: "cover",
                    maxHeight: 360
                  }}
                />
              </div>

              {/* Sağ tərəf — Mətn */}
              <div>
                <h1 style={{ marginTop: 0 }}>{post.title}</h1>
                <div className="pMuted" style={{ marginBottom: 10 }}>
                  <b>Tarix:</b> {post.date}
                </div>

                <hr />

                <div
                  style={{
                    whiteSpace: "pre-line",
                    lineHeight: 1.7,
                    fontSize: 15
                  }}
                >
                  {post.content}
                </div>

                <div style={{ marginTop: 20 }}>
                  <Link className="btn btnLight" to="/blog">← Geri</Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Mobil üçün düzəlişlər */}
      <style>{`
        @media (max-width: 860px){
          .container .card div[style*="grid"] {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </Layout>
  );
}
